/**
 * 元素动画- ‘Draw’涂抹动画
 */
(function (root, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        // CommonJS
        module.exports = factory(this);
    } else {
        //  全局变量
        factory(root);
    }
})(this, function (root) {
    var ImageLoader;
    // 类构造函数
    function con(sprite, option) {
        this.type = option.code || 'Hand'; //默认是从左移
    }

    var methods = {
        // 初始化位图的手绘路径
        _initImage: function() {
            var sprite = this.sprite,
                image = sprite.getImage(),
                attr = ImageLoader.constructAnimPath(image),
                editor = sprite.editor,
                player = editor.player, // 播放层
                playerSprite = player.spritesDict[sprite.uuid];

            // 添加svg dom
            var id = playerSprite.ele.empty().attr('id');
            var svg = SVG(id).style({
                position: 'absolute',
                top: 0,
                left: 0
            }).attr({
                id: 'anim-path-helper-' + sprite.id,
                viewBox: '0 0 ' + image.width + ' ' + image.height,
                preserveAspectRatio: 'none'
            });

            this.maskId = sprite.id + '-mask';

            // 添加一个group层，作为mask背景，生成一个svg的image元素
            var svgg = svg.group().style({
                mask: 'url(#' + this.maskId + '-mask)'
            });
            svgg.image(image.src, image.width, image.height).attr({
                preserveAspectRatio: 'none meet' // 设置宽高时允许变形
            });

            svg.mask().attr({
                id: this.maskId
            }).path().attr(attr);

            if(!sprite.loadFailed) {
                if(sprite.cropType === 'free') {
                    sprite.handleCrop(sprite.ele, $(svg.node), sprite);
                } else if(sprite.cropType === 'svg') {
                    var box =  sprite.cropBoxData;
                    var rW = sprite.width / box.width;
                    var rH = sprite.height / box.height;
                    if(sprite.draw) {
                        var defs = sprite.draw.select('defs').members[0].clone();
                        var clipPath = defs.children()[0];
                        clipPath.transform({
                            scaleX: sprite.width/sprite.bbox.w,
                            scaleY: sprite.height/sprite.bbox.h
                        }).attr('id', this.maskId + '-crop')
                        svg.defs().add(clipPath)
                        defs.remove()
                        svgg.attr('clip-path', 'url(#' + this.maskId + '-crop)')
                        svgg.children()[0].size(box.originWidth * rW, box.originHeight * rH)
                            .move(box.deltaX * rW, box.deltaY * rH)
                    }
                }
            }
            // 挂载svg对象
            this.svg = svg;
            this.playerSvgGroup = svgg;

            if(sprite.border) playerSprite.ele.append(sprite.border.dom.clone());
            sprite.setFilterCss();
        },

        // 初始化数据
        _initData: function() {
            this._initImage(); // 初始化位图的手绘路径

            this.item = {
                el: this.svg.select('path').members[0],
            }
            this.item.length = this.item.el.length();
            this.item.start = 0;
            this.item.end = 500;
            this.item.el.attr({
                opacity: 1,
                "stroke-width": Math.max(parseFloat(this.item.el.attr('stroke-width')), 1),
                "stroke-dasharray": this.item.length + ' ' + this.item.length,
                "stroke-dashoffset": -this.item.length
            }).style({stroke: 'white', fill: 'none'});
        },

        _init: function(bol) {
            bol && this._initData();
            this.isInit = true;

            return Promise.resolve();
        },

        init: function(start, index) {
            var _this = this;
            return this.supr(start).then(function() {
                return _this._init(start);
            }).catch(function(err) {
                // throw "Error: " + err;
                console.log('error: ', err);
            });
        },

        // 重置播放路径
        reset: function() {
            // todo...
        },

        outAnimFn: function(frame,playerEle) {
            this.supr(frame, playerEle);
            this.svg.hide();
            if (frame < this.animFrame.exit.start) this.playerSvgGroup.style('mask', 'url(#' + this.maskId + ')');
        },

        enterAnimFn: function(frame, playerEle) {
            this.supr(frame, playerEle);
            var _this = this;
            var sprite = this.sprite;
            var frameOff = frame - this.animFrame.entrance.start;

            this.svg.show();

            // 入场恢复初始位置
            if (
                playerEle.css('left') !== sprite.positionLeft ||
                playerEle.css('top') !== sprite.positionTop
            ) {
                playerEle.css({ left: sprite.positionLeft, top: sprite.positionTop });
            }

            // 设置mask
            this.playerSvgGroup.style({
                'mask': 'url(#' + this.maskId + ')',
                'display': 'block'
            })

            var item = this.item;

            var endFrame = this.ms2fps(item.end), startFrame = this.ms2fps(item.start);
            if (endFrame < frameOff) {
                item.el.attr({'stroke-dashoffset': 0, opacity: 1});
            } else if (startFrame < frameOff) {

                var length = item.length * (frameOff - startFrame) / (endFrame - startFrame);
                item.el.attr('stroke-dashoffset', item.length - length);

                // 手势
                if (this.entranceAnim.hand) {
                    var point = item.el.pointAt(length);
                    var vb = this.svg.viewbox();
                    var ratioW = vb.width / sprite.ele.width();
                    var ratioH = vb.height / sprite.ele.height();
                    point.x = (point.x - vb.x) / ratioW;
                    point.y = (point.y - vb.y) / ratioH;
                    var p = this._calcHandPosition(point.x, point.y, this.entranceAnim.hand);
                    var hand = this.entranceAnim.hand;
                    var transformOrigin = hand.x + 'px ' + hand.y + 'px';

                    this.entranceAnim.hand.ele.css({
                        display: 'block',
                        left:  p.x,
                        top: p.y,
                        transform: 'rotate(' + _this.sprite.rotate + 'deg) scale(' + 1 / _this.sprite.editor.scale / 0.625 + ')',
                        transformOrigin: transformOrigin
                    });
                }
            } else {
                item.el.attr('stroke-dashoffset', -item.length);
            }
        },

        stayAnimFn: function(frame, playerEle) {
            this.supr(frame, playerEle);

            this.playerSvgGroup.style({'mask': 'none'})
            if (this.sprite.type === "Image") {
                this.svg.style({'mask': 'none'});
                this.svg.select('img').show();
            }
        },

        // 计算手势中心位置
        _calcHandPosition: function (x, y, hand, center) {
            var v = this.handlePenPoint(x, y);
            var cx = v.x;
            var cy = v.y;
            return {
                x: cx - hand.x,
                y: cy - hand.y
            }
        },

        handlePenPoint (x, y, angle) {
            var sprite = this.sprite;
            angle = rad(this.sprite.rotate);
            var spriteCenter = {
                x: sprite.positionLeft + sprite.width / 2,
                y: sprite.positionTop + sprite.height / 2
            };
            var vTopLeft = {
                x: - sprite.width / 2,
                y: - sprite.height / 2
            }
            var v1 = {
                x: vTopLeft.x + x,
                y: vTopLeft.y + y
            };
            var v1r = {
                x: v1.x * Math.cos(angle) - v1.y * Math.sin(angle),
                y: v1.x * Math.sin(angle) + v1.y * Math.cos(angle)
            }

            function rad (deg) {
                return (deg * Math.PI) / 180
            }

            var v2 = {
                x: v1r.x + spriteCenter.x,
                y: v1r.y + spriteCenter.y
            }

            return v2;
        },
    }

    var statics = {};

    if (root.AnimEditor) {
        ImageLoader = root.AnimEditor.ImageLoader;
        root.AnimEditor.extendEffect('Hand', con, methods, statics);
        return;
    }

    return function (AnimEditor) {
        ImageLoader = AnimEditor.ImageLoader;
        AnimEditor.extendEffect('Hand', con, methods, statics);
    }
})



//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/sprite-effects/hand.js
// module id = kXOl
// module chunks = 16